import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBlock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M8 1.333C4.32 1.333 1.333 4.32 1.333 8c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667 0-3.68-2.987-6.667-6.667-6.667zM2.667 8c0-2.947 2.386-5.333 5.333-5.333 1.233 0 2.367.42 3.267 1.126l-7.474 7.474c-.706-.9-1.126-2.034-1.126-3.267zM8 13.333c-1.233 0-2.367-.42-3.267-1.126l7.474-7.474c.706.9 1.126 2.034 1.126 3.267 0 2.947-2.386 5.333-5.333 5.333z"
	})
});
export default SvgIconBlock;
